import * as XLSX from "xlsx-js-style";

export const TaskupdateExcel = (
  data = [],
  projectName = "",
  title = ""
) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([]);

  /* ================= TITLE ================= */
  XLSX.utils.sheet_add_aoa(ws, [["Task Update"]], { origin: "A1" });
  ws["A1"].s = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: "center" },
    fill: { fgColor: { rgb: "BDD7EE" } }
  };

  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }];

  /* ================= SUB TITLE ================= */
  XLSX.utils.sheet_add_aoa(
    ws,
    [[`${projectName} - ${title}`]],
    { origin: "A2" }
  );

  ws["A2"].s = {
    font: { bold: true },
    alignment: { horizontal: "center" },
  };

  ws["!merges"].push({ s: { r: 1, c: 0 }, e: { r: 1, c: 3 } });

  /* ================= TABLE HEADER ================= */
  XLSX.utils.sheet_add_aoa(
    ws,
    [["SL#", "Date", "Time", "Comments"]],
    { origin: "A4" }
  );

  const headerStyle = {
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center" },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    fill: { fgColor: { rgb: "EEF3FB" } },
  };

  ["A4", "B4", "C4", "D4"].forEach(cell => {
    ws[cell].s = headerStyle;
  });

  /* ================= TABLE DATA ================= */
  const tableData = data.map((row, index) => [
    index + 1,
    row.DailyTaskUpdateCreatedDate || "",
    row.DailyTaskUpdateCreatedTime || "",
    row.DailyTaskUpdateComments || "",
  ]);

  XLSX.utils.sheet_add_aoa(ws, tableData, { origin: "A5" });

  /* ================= ROW STYLING ================= */
  const range = XLSX.utils.decode_range(ws["!ref"]);
  const oddRowStyle = {
    fill: { fgColor: { rgb: "FFFFFF" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const evenRowStyle = {
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };


  for (let R = 4; R <= range.e.r; R++) {
     const baseStyle = R % 2 === 0 ? evenRowStyle : oddRowStyle;

    for (let C = 0; C < 4; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;

      ws[cell].s = {
        ...baseStyle,
        // border: {
        //   top: { style: "thin" },
        //   bottom: { style: "thin" },
        //   left: { style: "thin" },
        //   right: { style: "thin" },
        // },
        alignment: {
          horizontal: C === 0 ? "center" : "left",
          vertical: "center",
          wrapText: true,
        },
      };
    }
  }

  /* ================= COLUMN WIDTHS (MATCH PDF) ================= */
  ws["!cols"] = [
    { wch: 6 },   // SL#
    { wch: 14 },  // Date
    { wch: 12 },  // Time
    { wch: 100 }, // Comments (LONG TEXT)
  ];

  /* ================= EXPORT ================= */
  XLSX.utils.book_append_sheet(wb, ws, "Task Update");
  XLSX.writeFile(wb, "TaskUpdate.xlsx");
};

export default TaskupdateExcel;
